export const  GUARDAR_DATO ='GUARDAR_DATO'